import { CartIcon } from './CartIcon';

export type { TypeCartIconProps, TypeState, TypeColorScheme } from './types';
export default CartIcon;
